function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { calculatePercentageInPixels, calculateTimePercentages, isCastAvailable, isMobile, toHHMMSS } from "@common/services/helpers";
import request from "@common/services/request";
import { API_URL, INITIAL_TIME_FORMAT, KEY_ARROW_LEFT, KEY_ARROW_RIGHT, PLAYER_HANDLE_WIDTH, SECONDS_TO_REVERT, TIME_BEFORE_BUFFER } from "@config/constants";
import React, { Component } from "react";
var VIDEO_FULL_PROGRESS_IN_PERCENTAGE = 100;
var ProgressBar = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ProgressBar, Component);
    var _super = _create_super(ProgressBar);
    function ProgressBar(props) {
        _class_call_check(this, ProgressBar);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            currentTimeInPercentages: 0,
            liveProgressTimeInPercentages: 0,
            liveButtonLeftPositionInPX: 0,
            imageThumbnailLeftPositionInPX: 0,
            handleHalfWidth: PLAYER_HANDLE_WIDTH / 2,
            currentTimeCursor: 0,
            imageSource: null,
            showThumbnail: false
        };
        _this.progressBar = null;
        _this.liveButton = null;
        _this.liveProgressBar = null;
        _this.imageThumbnail = null;
        _this.isProgressBarMouseDown = null;
        _this.activeSlide = false;
        _this.changeCurrentTime = _this.changeCurrentTime.bind(_assert_this_initialized(_this));
        _this.calculateTime = _this.calculateTime.bind(_assert_this_initialized(_this));
        _this.setCurrentTimeInPercentages = _this.setCurrentTimeInPercentages.bind(_assert_this_initialized(_this));
        _this.setMouseDownEvents = _this.setMouseDownEvents.bind(_assert_this_initialized(_this));
        _this.showImageThumbnail = _this.showImageThumbnail.bind(_assert_this_initialized(_this));
        _this.hideImageThumbnail = _this.hideImageThumbnail.bind(_assert_this_initialized(_this));
        _this.returnToLive = _this.returnToLive.bind(_assert_this_initialized(_this));
        _this.getLiveButtonLeftPositionInPX = _this.getLiveButtonLeftPositionInPX.bind(_assert_this_initialized(_this));
        _this.getImageThumbnailLeftPosition = _this.getImageThumbnailLeftPosition.bind(_assert_this_initialized(_this));
        _this.handleImageLoadError = _this.handleImageLoadError.bind(_assert_this_initialized(_this));
        _this.navigateFromKeyboard = _this.navigateFromKeyboard.bind(_assert_this_initialized(_this));
        _this.mouseUp = function(event1) {
            event1.preventDefault();
            _this.changeCurrentTime(event1);
            _this.isProgressBarMouseDown = false;
            _this.activeSlide = false;
            _this.hideImageThumbnail(event1);
            document.removeEventListener("mousemove", _this.setCurrentTimeInPercentages);
            document.removeEventListener("touchmove", _this.setCurrentTimeInPercentages);
            document.removeEventListener("mouseup", _this.mouseUp);
            document.removeEventListener("touchend", _this.mouseUp);
        };
        return _this;
    }
    _create_class(ProgressBar, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this_props = this.props, currentTime = _this_props.currentTime, videoPlayer = _this_props.videoPlayer, liveProgress = _this_props.liveProgress;
                var currentTimeInPercentages = calculateTimePercentages(0, videoPlayer.video.duration, currentTime);
                var liveProgressTimeInPercentages = VIDEO_FULL_PROGRESS_IN_PERCENTAGE;
                if (videoPlayer.video.now) {
                    liveProgressTimeInPercentages = calculateTimePercentages(0, videoPlayer.video.duration, liveProgress - TIME_BEFORE_BUFFER);
                }
                this.setState({
                    currentTimeInPercentages: currentTimeInPercentages,
                    liveProgressTimeInPercentages: liveProgressTimeInPercentages,
                    liveButtonLeftPositionInPX: this.getLiveButtonLeftPositionInPX(liveProgressTimeInPercentages)
                });
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(param) {
                var _this = this;
                var videoPlayer = param.videoPlayer, currentTime = param.currentTime, liveProgress = param.liveProgress;
                // if (currentTime !== this.props.currentTime && !this.isProgressBarMouseDown) {
                var currentTimeInPercentages = calculateTimePercentages(0, videoPlayer.video.duration, currentTime);
                this.setState(function() {
                    return {
                        currentTimeInPercentages: currentTimeInPercentages
                    };
                });
                if (liveProgress !== this.props.liveProgress) {
                    var liveProgressTimeInPercentages = VIDEO_FULL_PROGRESS_IN_PERCENTAGE;
                    if (videoPlayer.video.now) {
                        liveProgressTimeInPercentages = calculateTimePercentages(0, videoPlayer.video.duration, liveProgress - TIME_BEFORE_BUFFER);
                    }
                    this.setState(function() {
                        return {
                            liveProgressTimeInPercentages: liveProgressTimeInPercentages,
                            liveButtonLeftPositionInPX: _this.getLiveButtonLeftPositionInPX(liveProgressTimeInPercentages)
                        };
                    });
                }
            }
        },
        {
            /**
     * Calculate time in seconds according the width of the progress bar and the duration of the video
     * @param event
     * @returns {number}
     */ key: "calculateTime",
            value: function calculateTime(event1) {
                var video = this.props.videoPlayer.video;
                var progressBarWidth = this.progressBar ? this.progressBar.clientWidth : 0;
                var liveProgressTimeInPercentages = this.liveProgressBar ? this.liveProgressBar.clientWidth : 0;
                var progressBarLeftPosition = this.progressBar.getBoundingClientRect().left;
                var relX = 0;
                if (event1.type === "touchend" || event1.type === "touchmove") {
                    relX = event1.changedTouches[event1.changedTouches.length - 1].pageX - progressBarLeftPosition >= 0 ? event1.changedTouches[event1.changedTouches.length - 1].pageX - progressBarLeftPosition : 0;
                } else {
                    relX = event1.pageX - progressBarLeftPosition >= 0 ? event1.pageX - progressBarLeftPosition : 0;
                }
                relX = video.isLiveEpg ? Math.min(relX, liveProgressTimeInPercentages) : Math.min(relX, progressBarWidth);
                return relX / progressBarWidth * video.duration;
            }
        },
        {
            key: "getImageThumbnailLeftPosition",
            value: function getImageThumbnailLeftPosition(event1) {
                var progressBarLeftPosition = this.progressBar.getBoundingClientRect().left;
                var progressBarWidth = this.progressBar.clientWidth;
                var imageThumbnailWidth = this.imageThumbnail.clientWidth;
                // Where cursor is
                var relX = event1.pageX - progressBarLeftPosition;
                var imageThumbnailLeftPositionInPX = null;
                if (relX < imageThumbnailWidth / 2) {
                    imageThumbnailLeftPositionInPX = 0;
                } else if (progressBarWidth - relX < imageThumbnailWidth / 2) {
                    imageThumbnailLeftPositionInPX = progressBarWidth - imageThumbnailWidth;
                } else {
                    imageThumbnailLeftPositionInPX = relX - imageThumbnailWidth / 2;
                }
                return imageThumbnailLeftPositionInPX;
            }
        },
        {
            /**
     * Change current time with the calculated seconds
     * @param event
     */ key: "changeCurrentTime",
            value: function changeCurrentTime(event1) {
                var time = this.calculateTime(event1);
                this.props.actions.setCurrentTime(time);
                var currentTimeInPercentages = calculateTimePercentages(0, this.props.videoPlayer.video.duration, time);
                this.setState(function() {
                    return {
                        currentTimeInPercentages: currentTimeInPercentages
                    };
                });
                if (isCastAvailable()) {
                    var castSession = cast.framework.CastContext.getInstance().getCurrentSession();
                    if (castSession) {
                        var seekRequest = new chrome.cast.media.SeekRequest();
                        var sessionId = castSession.getSessionId();
                        var mediaSession = castSession.getMediaSession();
                        var media = new chrome.cast.media.Media(sessionId, mediaSession.mediaSessionId);
                        seekRequest.currentTime = time;
                        media.seek(seekRequest);
                    }
                }
            }
        },
        {
            /**
     * Add mousemove and mouseup events to document when mousedown event on progress bar is fired
     */ key: "setMouseDownEvents",
            value: function setMouseDownEvents() {
                this.activeSlide = true;
                this.isProgressBarMouseDown = true;
                document.addEventListener("mousemove", this.setCurrentTimeInPercentages);
                document.addEventListener("touchmove", this.setCurrentTimeInPercentages);
                document.addEventListener("mouseup", this.mouseUp);
                document.addEventListener("touchend", this.mouseUp);
            }
        },
        {
            /**
     * Set current time in percentage when mousemove event is fired
     * @param event
     */ key: "setCurrentTimeInPercentages",
            value: function setCurrentTimeInPercentages(event1) {
                event1.preventDefault();
                var currentTimeInPercentages = calculateTimePercentages(0, this.props.videoPlayer.video.duration, this.calculateTime(event1));
                this.showImageThumbnail(event1);
                this.setState(function() {
                    return {
                        currentTimeInPercentages: currentTimeInPercentages
                    };
                });
            }
        },
        {
            /**
     * Return show to live time
     */ key: "returnToLive",
            value: function returnToLive() {
                event.stopPropagation();
                var _this_props = this.props, videoPlayer = _this_props.videoPlayer, actions = _this_props.actions;
                if (!videoPlayer.video.disableLiveButton) {
                    actions.setVideoToLive();
                }
            }
        },
        {
            /**
     * Show current cursor time
     * @param event
     */ key: "showImageThumbnail",
            value: function showImageThumbnail(event1) {
                var _this = this;
                if (!isMobile.any()) {
                    var time = this.calculateTime(event1);
                    var videoPlayer = this.props.videoPlayer;
                    var imageThumbnailLeftPositionInPX = this.getImageThumbnailLeftPosition(event1);
                    var imageSource = "".concat(API_URL, "/tumblrs/").concat(videoPlayer.channelId, "/").concat(8 * Math.round((videoPlayer.video.start + time) / 8));
                    if (videoPlayer.isVod) {
                        // https://play.b-box.bg/v1/tumblrs/vod/{id}/{index}
                        var url = "".concat(API_URL, "/tumblrs/vod/").concat(videoPlayer.channelId, "/").concat(String(Math.floor(time / 8)).padStart(5, "0"));
                        request({
                            method: "GET",
                            url: url,
                            responseType: "blob"
                        }).then(function(blob) {
                            imageSource = URL.createObjectURL(blob);
                            _this.setState(function() {
                                return {
                                    currentTimeCursor: time,
                                    imageSource: imageSource,
                                    imageThumbnailLeftPositionInPX: imageThumbnailLeftPositionInPX
                                };
                            });
                        });
                        this.setState(function() {
                            return {
                                showThumbnail: true
                            };
                        });
                    } else {
                        this.setState(function() {
                            return {
                                showThumbnail: true,
                                currentTimeCursor: time,
                                imageSource: imageSource,
                                imageThumbnailLeftPositionInPX: imageThumbnailLeftPositionInPX
                            };
                        });
                    }
                }
            }
        },
        {
            /**
     * Hide current cursor time
     */ key: "hideImageThumbnail",
            value: function hideImageThumbnail() {
                this.setState(function() {
                    return {
                        imageSource: null,
                        currentTimeCursor: 0,
                        showThumbnail: false
                    };
                });
            }
        },
        {
            /**
     * Calculate left button position based on progress bar width and current progress in percentages
     * @param liveProgressTimeInPercentages {number}
     * @returns {number}
     */ key: "getLiveButtonLeftPositionInPX",
            value: function getLiveButtonLeftPositionInPX(liveProgressTimeInPercentages) {
                var liveButtonLeftPositionInPX = null;
                var progressBarWidth = this.progressBar && this.progressBar.clientWidth;
                var liveButtonWidth = this.liveButton && this.liveButton.clientWidth;
                var liveProgressTimeInPixels = calculatePercentageInPixels(liveProgressTimeInPercentages, progressBarWidth);
                if (liveProgressTimeInPixels < liveButtonWidth / 2) {
                    liveButtonLeftPositionInPX = 0;
                } else if (progressBarWidth - liveProgressTimeInPixels < liveButtonWidth / 2) {
                    liveButtonLeftPositionInPX = progressBarWidth - liveButtonWidth;
                } else {
                    liveButtonLeftPositionInPX = liveProgressTimeInPixels - liveButtonWidth / 2;
                }
                return liveButtonLeftPositionInPX;
            }
        },
        {
            key: "handleImageLoadError",
            value: function handleImageLoadError() {
                this.setState(function() {
                    return {
                        imageSource: null
                    };
                });
            }
        },
        {
            /**
     * Enables firing of forward and backward action from keyboard
     * @param (event)
     */ key: "navigateFromKeyboard",
            value: function navigateFromKeyboard(event1) {
                var key = event1.which;
                if (key === KEY_ARROW_LEFT) {
                    this.props.actions.backward(SECONDS_TO_REVERT, true);
                }
                if (key === KEY_ARROW_RIGHT) {
                    this.props.actions.forward(SECONDS_TO_REVERT, true);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, videoPlayer = _this_props.videoPlayer, currentTime = _this_props.currentTime;
                var _this_state = this.state, currentTimeCursor = _this_state.currentTimeCursor, imageSource = _this_state.imageSource, currentTimeInPercentages = _this_state.currentTimeInPercentages, liveProgressTimeInPercentages = _this_state.liveProgressTimeInPercentages, liveButtonLeftPositionInPX = _this_state.liveButtonLeftPositionInPX, imageThumbnailLeftPositionInPX = _this_state.imageThumbnailLeftPositionInPX, handleHalfWidth = _this_state.handleHalfWidth, showThumbnail = _this_state.showThumbnail;
                var duration = videoPlayer.video.duration;
                var endTimeFormat = duration ? toHHMMSS(duration) : INITIAL_TIME_FORMAT;
                var currentTimeFormat = currentTime > 0 ? toHHMMSS(currentTime) : INITIAL_TIME_FORMAT;
                var currentTimeInPx = calculatePercentageInPixels(currentTimeInPercentages, this.progressBar ? this.progressBar.clientWidth : 0) - handleHalfWidth;
                var handleTemplate = /*#__PURE__*/ _jsx("div", {
                    className: "handle".concat(this.activeSlide ? " no-transition" : ""),
                    onMouseDown: this.setMouseDownEvents,
                    onTouchStart: this.setMouseDownEvents,
                    style: {
                        left: "".concat(currentTimeInPx, "px")
                    }
                });
                var currentTimeBarTemplate = /*#__PURE__*/ _jsx("div", {
                    className: "current-time-bar".concat(this.activeSlide ? " no-transition" : ""),
                    style: {
                        width: "".concat(currentTimeInPercentages, "%")
                    },
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "bar"
                    })
                });
                var imageThumbnailTemplate = showThumbnail ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        imageSource ? /*#__PURE__*/ _jsx("img", {
                            src: imageSource,
                            alt: "thumbnail",
                            onError: this.handleImageLoadError
                        }) : null,
                        /*#__PURE__*/ _jsx("div", {
                            className: "time",
                            children: toHHMMSS(currentTimeCursor)
                        })
                    ]
                }) : null;
                var progressBarTemplate = videoPlayer.video.isLiveEpg ? /*#__PURE__*/ _jsxs("div", {
                    className: "progress-bar live".concat(this.activeSlide ? " active-slide" : ""),
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "live-duration-bar",
                            ref: function(elem) {
                                return _this.progressBar = elem;
                            },
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "bar"
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "duration-bar",
                            onMouseMove: this.showImageThumbnail,
                            onMouseLeave: this.hideImageThumbnail,
                            onMouseDown: this.setMouseDownEvents,
                            onTouchStart: this.setMouseDownEvents,
                            tabIndex: "0",
                            onKeyDown: this.navigateFromKeyboard,
                            style: {
                                width: "".concat(liveProgressTimeInPercentages, "%")
                            },
                            ref: function(elem) {
                                return _this.liveProgressBar = elem;
                            },
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "bar"
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "live-button",
                            onClick: this.returnToLive,
                            style: {
                                left: "".concat(liveButtonLeftPositionInPX, "px")
                            },
                            ref: function(elem) {
                                return _this.liveButton = elem;
                            },
                            children: "LIVE"
                        }),
                        currentTimeBarTemplate,
                        handleTemplate
                    ]
                }) : /*#__PURE__*/ _jsxs("div", {
                    className: "progress-bar ".concat(this.activeSlide ? " active-slide" : ""),
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "duration-bar",
                            ref: function(elem) {
                                return _this.progressBar = elem;
                            },
                            onMouseMove: this.showImageThumbnail,
                            onMouseLeave: this.hideImageThumbnail,
                            onMouseDown: this.setMouseDownEvents,
                            onTouchStart: this.setMouseDownEvents,
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "bar"
                            })
                        }),
                        currentTimeBarTemplate,
                        handleTemplate
                    ]
                });
                return /*#__PURE__*/ _jsxs("div", {
                    className: "progress-bar-wrapper player",
                    children: [
                        progressBarTemplate,
                        /*#__PURE__*/ _jsx("span", {
                            className: "current-time",
                            children: currentTimeFormat
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "end-time",
                            children: endTimeFormat
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "image-thumbnail",
                            style: {
                                left: "".concat(imageThumbnailLeftPositionInPX, "px")
                            },
                            ref: function(elem) {
                                return _this.imageThumbnail = elem;
                            },
                            children: imageThumbnailTemplate
                        })
                    ]
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("mousemove", this.setCurrentTimeInPercentages);
                document.removeEventListener("touchmove", this.setCurrentTimeInPercentages);
                document.removeEventListener("mouseup", this.mouseUp);
                document.removeEventListener("touchend", this.mouseUp);
            }
        }
    ]);
    return ProgressBar;
}(Component);
export default ProgressBar;
